import { render, staticRenderFns } from "./unitEntryByModel.vue?vue&type=template&id=3a67a8e1&scoped=true"
import script from "./unitEntryByModel.vue?vue&type=script&lang=js"
export * from "./unitEntryByModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67a8e1",
  null
  
)

export default component.exports